import React from 'react';
import './MiniGameCard.css';
import { MiniGameCardProps } from '../types';

const MiniGameCard: React.FC<MiniGameCardProps> = ({
    title,
    description,
    rewardAmount,
    gameType,
    characterImage,
    onPlayClick,
    isAvailable = true
}) => {
  const getDefaultCharacter = (type: string): string => {
    const characterImages: { [key: string]: string } = {
        'quiz': '/images/minigames/bg_game1.png',
        '9tangmay': '/images/minigames/bg_game3.png',
        'didua': '/images/minigames/bg_game2.png',
    };
    
    return characterImages[type] || '/images/icons/miniquiz.png';
  };

  const getGameTypeDisplay = (type: string): string => {
    const gameTypes: { [key: string]: string } = {
        'quiz': 'Mini-Quiz',
        '9tangmay': 'KILOBA 9 Tầng Mây',
        'didua': 'KILOBA Đi Đua',
    };
    
    return gameTypes[type] || 'Mini-Game';
  };

  return (
    <div className="mini-game-card">
      <img 
        src={characterImage || getDefaultCharacter(gameType)}
        alt="Background" 
        className="mini-game-card__background" 
      />
    
      <div className="mini-game-card__action-bar">
          <div className="mini-game-card__reward">
              <span className="mini-game-card__reward-label">Phần thưởng</span>
              <div className="mini-game-card__energy-icon">
                  <img 
                      src="/images/energy-icon-background.svg" 
                      alt="Energy Background"
                      className="mini-game-card__energy-bg"
                  />
                  <img 
                      src="/images/energy-icon.svg" 
                      alt="Energy"
                      className="mini-game-card__energy-icon"
                  />
              </div>
              <span className="mini-game-card__reward-amount">x{rewardAmount}</span>
          </div>

          {/* Play Button */}
          <button 
              className={`mini-game-card__play-btn ${!isAvailable ? 'mini-game-card__play-btn--disabled' : ''}`}
              onClick={onPlayClick}
              disabled={!isAvailable}
          >
              Chơi ngay
          </button>
      </div> 
    </div>
  );
};

export default MiniGameCard;


// Bottom Action Bar
                         